import { gql } from '@apollo/client';
import { PAGE_MODULE_DETAILS_FRAGMENT } from '../../pages/graphql/Queries';

export const GET_PAGE_TEMPLATES = gql`
  query pageTemplates($filter: PageTemplatesFilter, $sort: PagesSort) {
    pageTemplates(filter: $filter, sort: $sort) {
      count
      pages {
        id
        title
        templateName
        type
        isDefault
        isTemplate
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_PAGE_TEMPLATE_DETAILS = gql`
  ${PAGE_MODULE_DETAILS_FRAGMENT}
  query pageTemplateAdmin($id: ID!) {
    pageTemplate(where: { id: $id }) {
      slug
      title
      description
      metaHeader
      metaFooter
      metaImage
      permissions
      allowDelete
      isDefault
      isTemplate
      templateName
      type
      pageGroup {
        name
        id
      }
      apps {
        id
        name
      }
      modules {
        ...pageModuleDetails
      }
    }
  }
`;
